const OfferingAdminDetailFetching = () => {
  return (
    <div className="row u-margin-bottom-xs">
      <div className="col-xs-6">
        <h4 className="u-text-light">Aanbod ophalen...</h4>
      </div>
    </div>
  );
};

export default OfferingAdminDetailFetching;
